import {
    memo,
    ReactElement,
    ButtonHTMLAttributes
} from "react";
import { CiHeart } from "react-icons/ci";


interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
}

export function Footer({ }: Props, props: any): ReactElement {
    return (
        <div className="footer">
            <div className="copyright">
                Develop with <CiHeart /> by <span className="colorful"> Karamad Team </span> .
            </div>
        </div>
    )
}

export default memo(Footer);
